import React from 'react';
import {
  IWeeklyConfig,
  DAY_NAMES_ENG,
  WEEK_DAYS_ENG,
} from '../interfaces/schedule-period.interface';
import { DayConfigRow } from './day-config-row';
import styles from './settings.module.scss';

interface IWeeklyFormProps {
  value: IWeeklyConfig;
  onChange: (value: IWeeklyConfig) => void;
}

export const WeeklyForm: React.FC<IWeeklyFormProps> = ({ value, onChange }) => {
  return (
    <div className={styles.form_content}>
      {WEEK_DAYS_ENG.map((day) => (
        <DayConfigRow
          key={day}
          label={DAY_NAMES_ENG[day]}
          value={value[day]}
          onChange={(newConfig) => onChange({ ...value, [day]: newConfig })}
        />
      ))}
    </div>
  );
};
